const FR = {
  placeholders: {
    username: 'Nom d\'utilisateur',
    password: 'Mot de passe',
    tagsEx: 'Nom de marque, type d’industrie, ...',
    projSubProj: 'projet/sous-projet',
    aoiName: 'Nom de l\'analyse AOI',
  },
  titles: {
    latestProjects: 'Derniers projets ouverts',
    addMedias: 'Ajouter un média',
    newProject: 'Nouveau projet',
    myProjects: 'Mes projets',
    allProjects: 'Tous les projets',
    preview: 'Aperçu',
    noImage: 'Pas d\'image',
    startAnalyze: 'Êtes-vous sûr de vouloir démarrer l\'analyse ?',
    youMustSelectImg: 'Vous devez sélectionner une image avant de cliquer sur une icône',
    sort: 'Trier',
    display: 'Affichage',
    youWillDelete: 'Vous allez supprimer ce projet | Vous allez supprimer ces projets',
    moveMedia: 'Déplacer le(s) média(s)',
    selectOrCreate: 'Sélectionner ou créer un nouveau projet',
    aoiSelection: 'Sélection AOI',
    layerArea: 'Zone(s) selectionnee(s)',
    tools: 'Outils de selection',
    noImgSelect: 'Pas d\'image sélectionnée',
    aoiNameRequired: 'Nom de l\'analyse AOI',
    polygon: 'Polygone',
    rectangle: 'Rectangle',
    circle: 'Cercle',
    account: 'Compte',
    kindOfProject: 'Quel est le type de projet que vous désirez créer ?',
    kindAddTags: 'Ajouter les tags pour ces images',
    deleteImgs: 'Êtes-vous sûr de vouloir supprimer ces image(s)/rapport(s) ?',
    sendAnalyzes: 'Êtes-vous sûr de vouloir analyser la/les zone(s) sélectionnée(s) ?',
    badImg: 'Mauvais format',
    downNoBasic: 'Veuillez attendre que le rapport de base soit disponible avant de le télécharger',
    aoiNoBasic: 'Veuillez attendre que le rapport de base soit disponible avant de faire une analyse AOI',
  },
  texts: {
    addAndRetry: 'Ajoutez un média et réessayez',
    jobTitle: 'Profession',
    jobDescription: 'Description de l\'emploi',
    firstName: 'Prénom',
    lastName: 'Nom',
    userName: 'Nom d\'utilisateur',
    email: 'E-mail',
    phone: 'Téléphone',
    address: 'Adresse',
    language: 'Langue',
    infoCreateProject: 'Si le projet n’existe pas, il sera créé',
    nbrImages: 'Nombre d’image(s) analysée(s) ',
    projectType: 'Type de projet',
    tags: 'Tag(s)',
    destinationFolder: 'Folder de destination',
    columns: 'Colonnes',
    defineAreasRequired: 'Vous devez définir des zones sur ces images pour les sélectionner. Ensuite, vous pouvez les analyser.',
    aoiNameRequired: 'Le nom de l’analyse AOI est requis pour chaque image avec une/des zone(s) sélectionnée(s). Veuillez entrer un nom.',
    noImgYet: 'Il n\'y a pas d\'images pour le moment.',
    createNewProj: 'Créer un nouveau',
    proj: 'projet',
    subProj: 'sous-projet',
    addToParent: 'Ajouter à un projet parent',
    delReportBASIC: 'En supprimant le rapport de base, vous supprimerez cette image et tous les rapports qui y sont liés.',
    delReportAOI: 'Vous allez supprimer le rapport <strong>{name}</strong>',
    delReportALL: 'Vous allez supprimer <strong>cette image</strong> avec <strong>tous</strong> les rapports liés !',
    delProjects: 'Avec ses <strong>{nbr}</strong> média(s)',
    analyzeAOIName: 'Nom de l\'analyse AOI: <strong>{aoiName}</strong>',
    analyzeImgName: 'Nom de l\'image: <strong>{imgName}</strong>',
    analyzeSelections :'Sélection(s): <strong>{nbrSelections}</strong>',
    accountLevel: 'Type d\'abonnement',
    consomation: 'Nombre d\'analyses ce mois',
    badImg: 'Désolé, nous ne pouvons pas transférer votre/vos image(s) car ce n\'est pas un fichier jpeg ou png. Veuillez réessayer avec l\'extension correcte.',
  },
  buttons: {
    cancel: 'Annuler',
    next: 'Suivant',
    login: 'Se connecter',
    packaging: 'Packaging',
    retail: 'Retail',
    reflex: 'Reflex',
    add: 'Ajouter',
    ad: 'Pub',
    web: 'Web',
    natural: 'Nature',
    magazine: 'Magazine',
    leaflet: 'Imprimé',
    analyzeAll: 'Tout analyser',
    back: 'Retour',
    analyze: 'Analyser',
    delete: 'Supprimer',
    sort: 'Trier',
    size: 'Vue',
    download: 'Télécharger',
    moveTo: 'Déplacer vers',
    aoi: 'AOI',
    close: 'Fermer',
    deleteAll: 'Tout supprimer',
    move: 'Déplacer',
    profile: 'Profil',
    logout: 'Se déconnecter',
    edit: 'modifier',
    create: 'Créer',
  },
  labels: {
    tags: 'Tags',
    chooseOrCreate: 'Choisir/Créer un projet',
    projectName: 'Nom du projet',
    parentProj: 'Projet parent',
  },
  errors: {
    fieldRequired: 'Ce champ est requis',
    nameProjRequired: 'Le nom du nouveau projet est requis',
    childProjExist: 'Ce projet enfant existe déjà',
    parentProjExist: 'Ce prrojet existe déjà. Choisissez un parent ou renommez le',
  },
}

export default FR;